module.exports = __webpack_public_path__ + "src/assets/img/page1/1e646c2962eb3a114a1476b49a7ba9e1.png";